import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=b1c700aa&scoped=true"
import script from "./productlist.vue?vue&type=script&lang=js"
export * from "./productlist.vue?vue&type=script&lang=js"
import style0 from "./productlist.vue?vue&type=style&index=0&id=b1c700aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c700aa",
  null
  
)

export default component.exports